module.exports = __webpack_public_path__ + "img/IMG_3119_FoamcoreMatted.782ae39c.jpg";